
function setToolBarPosition() {
  
  // toolbar 自适应高度
    const headerDom = document.getElementById('sticky-header-content');
    const toolBarDom = document.querySelectorAll('.section-multicolumn');
    const aHeight = headerDom.offsetHeight;
    console.log("aHeight233",aHeight);
    console.log("toolBarDom233",toolBarDom);


    toolBarDom[0].style.top = aHeight + 'px';
};
setToolBarPosition();